import React, { Component } from 'react';
import { Stack } from 'react-bootstrap';
import Grid2d from '../../Common/Grid2d';
import { getTextureUrl } from '../../Common/TextureTools';

import './robots.css'



class SpinningRobots extends Component {
    constructor(props) {
        super(props);
        this.src = getTextureUrl(157);
    }
    render() {
        const src = this.src;
        const activatedCount = this.props.activated;
        return <div className={'spinning-robots-container'}
        >

            <div className={'activated-robot-parent'}
            >
                <div className={'activated-robot activated-robot-0'}>
                    <img
                        src={src}
                        alt="robot"
                        className={'activated-room-robot'}
                    />
                </div>
                {activatedCount > 1 &&
                    <div className={'activated-robot activated-robot-1'}>
                        <img
                            src={src}
                            alt="robot"
                            className={'activated-room-robot'}
                        />
                    </div>
                }
                {activatedCount > 2 &&
                    <div className={'activated-robot activated-robot-2'}>
                        <img
                            src={src}
                            alt="robot"
                            className={'activated-room-robot'}
                        />
                    </div>
                }
            </div>
        </div>;
    }
}




class RobotComponent extends Component {

    onClicked = () => {
        if (this.props.robot) this.props.onClicked(this.props.robot);
    }

    render() {
        let className = 'small-robot';
        let src;
        const robot = this.props.robot;
        if (robot) {
            src = getTextureUrl(157);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }
        let gamePlayerData = this.props.gamePlayerData;
        let existingMarket = gamePlayerData.robot_market;
        let existingStorage = gamePlayerData.robot_storage;

        let highlight = false;
        if (robot) {
            if (this.props.robotMarket) {
                if (!existingMarket.includes(robot)) highlight = true;
            }
            if (this.props.storedRobotsToHighlight && this.props.storedRobotsToHighlight.includes(robot)) {
                highlight = true;
            }
        } else {
            highlight = false;
        }


        return <div onClick={this.onClicked}
                    style={{position: 'relative', width: '50px', height: '50px'}}>
            {highlight && <div className={'robot-highlighter'}/>}

            <div style={{position: 'absolute', width: '50px', height: '50px'}}>
            <img
                src={src}
                alt="robot"
                className={className}
                onClick={this.onClicked}
            />
        </div>
        </div>;
    }
}



export default class Robots extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saleUnderway: false,
            soldRobots: [],
            // robotMarket: [ 3, 4, 5, 6, 7, 8 ],
            // robotStorage: [ 1, 2 ],
            currentFate: 0,
            textureId: 1,
            juice: true,
            multiplier: 2,
            centerTexture: 155,
            callback: null
        }
    }

    onStorageClicked = (robot) => {
        // remove from storage, add to market.
        if (!this.state.saleUnderway) return;
        let newRobots = [...this.state.soldRobots, robot];

        let gamePlayerData = this.props.gamePlayerData;
        let robotStorage = gamePlayerData.robot_storage;
        let storageIndex = robotStorage.indexOf(robot);
        if (storageIndex < 0) return;

        this.setState({
            saleUnderway: true,
            soldRobots: newRobots
        }, this.setActionGrid);
    }

    onMarketClicked = (robot) => {
        if (!this.state.saleUnderway) return;

        let newRobots = this.state.soldRobots;
        let robotIndex = newRobots.indexOf(robot);
        if (robotIndex < 0) return;
        newRobots.splice(robotIndex, 1);

        this.setState({
            saleUnderway: true,
            soldRobots: newRobots
        }, this.setActionGrid);
    }

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let robotMarket = gamePlayerData.robot_market.filter(Number);
        let robotStorage = gamePlayerData.robot_storage;

        this.state.soldRobots.forEach(robot => robotMarket.push(robot));
        if (robotMarket.length < 6) {
            new Array(6 - robotMarket.length).fill(null).forEach(
                () => robotMarket.push(null));
        }
        let marketStackRobotCount = robotMarket.filter(Number).length;


        robotStorage = robotStorage.map(robot => {
            if (robotMarket.includes(robot)) return null;
            return robot;
        });
        robotStorage = robotStorage.filter(Number);
        if (robotStorage.length < 6) {
            new Array(6 - robotStorage.length).fill(null).forEach(
                () => robotStorage.push(null));
        }
        let storageStackRobotCount = robotStorage.filter(Number).length;

        let numberOnTop = 0;
        // if only 2 and market full
        if (marketStackRobotCount === 6 && storageStackRobotCount < 3) {
            numberOnTop = storageStackRobotCount;
            let robots = robotStorage.filter(Number);
            new Array(numberOnTop).fill(null).forEach(() => {
                let robot = robots.pop();
                let robotIndex = robotStorage.findIndex(
                    storedRobot => storedRobot === robot);
                robotStorage.splice(robotIndex, 1);
            })
        }
        // if more than 6
        if (storageStackRobotCount > 6) {
            numberOnTop = storageStackRobotCount - 6;
            robotStorage = robotStorage.slice(0, 6);
        }

        let storedRobotsToHighlight = [];
        let highlight = false;
        if (this.state.saleUnderway) {
            let highlightCount = 6 - marketStackRobotCount;
            storedRobotsToHighlight = robotStorage.slice(
                robotStorage - highlightCount, highlightCount);
            highlight = marketStackRobotCount < 6;

            // anti-juice when reaching zero.
            if (!this.state.juice) {
                let remainingFate = this.state.currentFate - (this.state.soldRobots.length * this.state.multiplier);
                if (remainingFate === 0) {
                    storedRobotsToHighlight = [];
                    highlight = false;
                }
            }

        }


        return <div className={'robot-container'}>
            <div id={'market'} className={'robot-container-left'}>
                <Stack style={{flexDirection: 'column-reverse'}}>
                    {robotMarket.map((robot, index) => {
                        return <RobotComponent
                            key={index}
                            robot={robot}
                            onClicked={this.onMarketClicked}
                            robotMarket={robotMarket}
                            saleUnderway={this.state.saleUnderway}
                            {...this.props}
                        />
                    })
                    }
                </Stack>
            </div>
            <div id={'storage'} className={'robot-container-right'}>
                {numberOnTop > 0 && <SpinningRobots activated={numberOnTop}/>}
                    <Stack style={{ flexDirection: 'column-reverse' }}>
                        {robotStorage.map((robotId, index) => {
                            return <RobotComponent
                                key={index}
                                robot={robotId}
                                highlight={highlight}
                                onClicked={this.onStorageClicked}
                                robotStorage={robotStorage}
                                saleUnderway={this.state.saleUnderway}
                                storedRobotsToHighlight={storedRobotsToHighlight}
                                {...this.props}
                            />
                        })
                        }
                    </Stack>
            </div>
        </div>;
    }
}


// competitor
export class RobotMarket extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.grid = new Grid2d(8, true);
        // this.fillGrid();
    }

    item = () => {
        return <img
            src={getTextureUrl(157)}
            alt="robot"
            style={{ width: '20px' }}
            onClick={() => {
                console.log('click');
            }}
        />;
    };


    fillGrid = () => {
        let emptyGrid = [ ...Array(175).keys() ];
        let station = [ 1, 2, 3, 4, 5, 6, ];
        station.forEach((gridId, index) => {
            this.grid.moveItemToGridId(this.item(), gridId);
        });
    };


    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let robotMarket = gamePlayerData.robot_market;
        let robotStorage = gamePlayerData.robot_storage;
        const emptyStorage = [1, 2, 3, 4, 5, 6, 7, 8];

        return <div className={'robot-market-anchor'}>
            <div className={'robot-market-container'}>

                {/* {this.grid.render()} */}

                {robotMarket.map((robot, index) => {
                    let gridIndex = index + 1;
                    if (robot === null) return <div
                        key={`robot-market-${index}`}></div>
                    return <div
                        id={`robot-grid-${gridIndex}`}
                        key={`robot-market-${index}`}
                        className={`robot-grid-${gridIndex}`}>
                        {this.item()}
                    </div>;
                })
                }
            </div>
        </div>;
    }
}


